import { memo } from 'react'

const Footer = memo(() => {
  return <footer>{/* Footer content will be added later */}</footer>
})

Footer.displayName = 'Footer'

export default Footer
